var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.items, function(item, index) {
        return _c(
          "div",
          {
            key: item.id,
            staticClass: "card card-body mb-4 relative pt-8 bordered",
            attrs: { name: _vm.listId + "-" + item.id }
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "absolute top-0 left-0 btn-primary rounded py-1 px-2 -ml-1 -mt-1"
              },
              [
                _c("span", { staticClass: "font-small-2" }, [
                  _vm._v("#" + _vm._s(index + 1))
                ])
              ]
            ),
            _vm._t("default", null, { id: item.id, item: item, index: index }),
            _c(
              "vx-tooltip",
              {
                staticClass: "absolute top-0 right-0 -mr-1 -mt-1",
                attrs: { text: "Eliminar ítem", position: "top" }
              },
              [
                _c("vs-button", {
                  staticClass: "rounded py-1 px-2",
                  attrs: { size: "small", color: "danger", icon: "clear" },
                  on: {
                    click: function($event) {
                      return _vm.removeItem(index)
                    }
                  }
                })
              ],
              1
            )
          ],
          2
        )
      }),
      _c(
        "b-button",
        {
          staticClass: "btn-block",
          attrs: { variant: "primary", size: "sm" },
          on: { click: _vm.addItem }
        },
        [_vm._v(" Agregar ítem ")]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }